export default "46279d783adaa0448812b000021b3d88.png";